/**
 * @generated SignedSource<<e612b8b18fa36a675128a773cd0c3151>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespQuickFilterDropdown_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbRespRefineMenuFilterArtSize_user" | "SbRespRefineMenuFilterPrice_user">;
  readonly " $fragmentType": "SbRespQuickFilterDropdown_user";
};
export type SbRespQuickFilterDropdown_user$key = {
  readonly " $data"?: SbRespQuickFilterDropdown_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespQuickFilterDropdown_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespQuickFilterDropdown_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterPrice_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterArtSize_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "616ffdc0cd7bab0597a8358363531085";

export default node;
